import styles from './EventsFIlterMenu.module.css'
import { useState } from 'react'
import CustomButton from '../UI/CustomButton/CustomButton'
import CustomRadio from '../UI/CustomRadio/CustomRadio'
import exitIcon from '../../assets/icons/close.svg'
import arrowLeft from '../../assets/icons/arrowLeft.svg'
import CustomModal from '../UI/CustomModal/CustomModal'
import FilterCompanyMobile from '../FilterCompanyMobile/FilterCompanyMobile'
import FilterPlacesMobile from '../FIlterPlacesMobile/FilterPlacesMobile'

interface Props {
  onClickHandler: () => void
  dateBlock: JSX.Element
  companies: any
  places: any
  companiesOnChange: (selected: any) => void
  placesOnChange: (selected: any) => void
  setActiveFilteByPlace: (selected: string) => void
  resetFilters: JSX.Element
}

const EventsFilterMenu: React.FC<Props> = ({
  onClickHandler,
  dateBlock,
  companies,
  places,
  companiesOnChange,
  placesOnChange,
  setActiveFilteByPlace,
  resetFilters,
}) => {
  const [activeFilter, setActiveFilter] = useState<string>('Компания')
  const [filterCompany, setFilterCompany] = useState(false)
  const [filterPlaces, setFilterPlaces] = useState(false)

  return (
    <div className={styles.filterContainer}>
      <CustomModal visible={filterCompany} setVisible={setFilterCompany}>
        <FilterCompanyMobile
          setUserFilter={companiesOnChange}
          companiesReports={companies}
          onClickHandler={() => setFilterCompany(false)}
          closeFilter={onClickHandler}
        />
      </CustomModal>
      <CustomModal visible={filterPlaces} setVisible={setFilterPlaces}>
        <FilterPlacesMobile
          setPlaceFilter={placesOnChange}
          placeNamesReports={places}
          onClickHandler={() => setFilterPlaces(false)}
          closeFilter={onClickHandler}
        />
      </CustomModal>
      <div className={styles.wrapper}>
        <div className={styles.header}>
          <h3>Фильтры</h3>
          <div className={styles.iconContainer} onClick={onClickHandler}>
            <img className={styles.exitIcon} src={exitIcon} alt='exitIcon' />
          </div>
        </div>
        <div className={styles.content}>
          <div className={styles.radioWrapper}>
            <h3>Тип</h3>
            <CustomRadio
              column={true}
              options={['Компания', 'Зал']}
              name='role'
              value={activeFilter}
              onChange={(e) => {
                setActiveFilter(e.target.value)
                setActiveFilteByPlace(e.target.value)
              }}
            />
          </div>
          {activeFilter === 'Компания' ? (
            <div onClick={() => setFilterCompany(true)} className={styles.itemContainer}>
              <div>Компании</div>
              <img src={arrowLeft} />
            </div>
          ) : (
            <div onClick={() => setFilterPlaces(true)} className={styles.itemContainer}>
              <div>Залы</div>
              <img src={arrowLeft} />
            </div>
          )}
          {dateBlock}
          {resetFilters}
        </div>
      </div>
      <div className={styles.footerContainer}>
        <CustomButton
          title='Применить'
          className={styles.filtersBtn}
          type='button'
          onClick={() => {
            onClickHandler()
          }}
        />
      </div>
    </div>
  )
}

export default EventsFilterMenu
